/* src/app/core/components/mission-card/mission-card.component.scss */
.mission-card {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 5px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.8);
  margin: 5px auto;
  max-width: 284px;
}
.mission-card img {
  border-radius: 100px;
  width: 48px;
  height: 48px;
  object-fit: cover;
}
.mission-card:hover {
  cursor: pointer;
}
.mission-card .content {
  margin-left: 15px;
}
.profile {
  display: flex;
  align-items: center;
  flex-direction: row;
  min-width: 48px;
}
.name {
  font-weight: bold;
}
.todo {
  color: rgb(0, 0, 0);
}
/*# sourceMappingURL=mission-card.component.css.map */
